// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  margin: 0;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen",
    "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue",
    sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  /* background-color: hsl(228, 25%, 88%); */
}

code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, "Courier New",
    monospace;
}

.wrapper {
  width: 95vw;
  margin: 0 auto;
  display: block;
}

.wrapper {
  width: 95%;
  /* height: 100vh; */
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0 auto;
  max-width: 1200px;
}

/* Join Room */
.join {
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 400px;
  gap: 10px;
  padding: 40px 20px;
  border-radius: 10px;
  box-shadow: 0 2px 8px 2px rgb(164, 165, 168);
  margin: 0 auto;
}

.join input,
select,
button {
  height: 45px;
  border: none;
  outline: none;
  color: rgb(59, 60, 62);
  border-radius: 4px;
  border: 1px solid rgb(182, 184, 190);
  font-size: 16px;
}

.join input::placeholder,
select::placeholder {
  color: hsl(223, 3%, 56%);
}

.join input,
select {
  padding: 0 10px;
}

.join button:hover {
  background-color: inherit;
}

.join button:active {
  background-color: rgb(201, 205, 220);
}

/* ChatNdParticipants */
.rightBox {
  border: 1px #c2c2c2 solid;
  border-radius: 10px;
  width: 30%;
  background-color: white;
  min-width: 250px;
  padding: 20px 15px;
  height: 100%;
}

.rightBox__optionView {
  height: calc(100% - 45px);
}

.rightBox__head {
  width: 100%;
  text-align: left;
  height: auto;
  min-height: 45px;
  display: flex;
  flex-wrap: nowrap;
  justify-content: flex-start;
  flex-direction: row;
  align-items: center;
  vertical-align: middle;
  position: relative;
}

.rightBox__head .selected {
  color: black;
}

.rightBox__head span {
  font-weight: bold;
  color: #a6a8ab;
  cursor: pointer;
}

.rightBox__head span:nth-child(1) {
  margin-right: 10px;
}

.rightBox__head button {
  position: absolute;
  right: 0;
}

.rightBox__chats {
  height: calc(100% - 40px);
  overflow: scroll;
  padding: 10px 0;
  scrollbar-width: none;
}

.rightBox__chats::-webkit-scrollbar {
  display: none;
}

.rightBox__optionView form input {
  border: none;
  width: 100%;
  height: 40px;
  background-color: hsl(228, 25%, 88%);
  border-radius: 10px;
  padding: 0 10px;
  box-sizing: border-box;
}

.rightBox__optionView form input:focus {
  outline: none;
}

.rightBox__participants {
  padding: 10px 0;
  height: 100%;
  overflow: scroll;
  scrollbar-width: none;
  /* Firefox */
}

.rightBox__participants::-webkit-scrollbar {
  display: none;
}

.rightBox__participant {
  text-align: left;
  text-align: left;
  background-color: #e9ebef;
  padding: 10px;
  border-radius: 10px;
  margin-bottom: 10px;
}

.rightBox__participant p {
  font-size: 14px;
}

/* Controls */
.controls {
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: center;
  padding: 20px 0;
  height: 80px;
  margin-top: 10px;
  background-color: white;
  border-radius: 10px;
  gap: 10px;
}

.controls .MuiButton-root .MuiSvgIcon-root {
  margin-right: 5px;
}

.controls .MuiButton-root img {
  height: 20px;
  width: 20px;
  margin-left: 5px;
}

.controls .MuiButton-root {
  text-transform: unset;
  padding: 10px;
  border-radius: 10px;
}

.controls .leave {
  background-color: rgb(241, 110, 110);
}

.controls .leave:hover {
  background-color: rgb(242, 87, 87);
}

/* HlsView and VideoTile */
video {
  width: 100%;
  height: 100%;
  /* object-fit: cover; */
  /* border-radius: 10px; */
}

.video {
  width: calc(50% - 10px);
  height: unset;
}

.video-theater {
  width: 100%;
  height: calc(100vh - 180px);
  background-color: black;
}

/* Message */
.message {
  width: -moz-fit-content;
  width: fit-content;
  text-align: left;
  max-width: 90%;
}

.message span {
  font-size: 12px;
  color: rgb(191, 196, 199);
  display: block;
}

.message p {
  background-color: hsl(228, 10%, 90%);
  padding: 5px 10px;
  border-radius: 10px;
  font-size: 14px;
  overflow: hidden;
  margin-bottom: 5px;
}

.myMessage {
  margin-left: auto;
  text-align: right;
}

.myMessage p {
  background-color: #1d84ea;
  color: white;
}

/* Room */
.room {
  display: flex;
  width: 95vw;
  height: 72vh;
  border: 1px white solid;
  gap: 10px;
}

.room__streamSpace {
  width: 100%;
  height: 100%;
  border: 1px #c2c2c2 solid;
  border-radius: 10px;
}

/* .liveStream {
  border-radius: 10px;
  border: 1px black solid;
  height: calc(100% - 90px);
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  flex-wrap: wrap;
  overflow: hidden;
} */

/* Stream */
.stream {
  /* border: 1px black solid; */
  background-color: #202124;
  border-radius: 10px;
  height: calc(100% - 90px);
  display: flex;
  align-items: center;
  justify-content: center;
  /* gap: 10px; */
  flex-wrap: wrap;
  overflow: hidden;
}

.mainroom {
  display: flex;
  justify-content: flex-start;
  background-color: #202124;
  position: fixed;
  border-radius: 0;
  border: none;
  width: 100vw;
  height: 100vh;
  z-index: 99;
  gap: 0px;
  left: 0;
  bottom: 0;
}

.mainroom .room__streamSpace {
  position: relative;
  width: 100%;
  height: 100%;
  border: none;
  top: inherit;
  left: inherit;
  border-radius: 0;
}

.mainroom .rightBox {
  position: relative;
  width: 50%;
  height: 100%;
  border: none;
  top: inherit;
  left: inherit;
  border-radius: 0;
  min-width: 300px;
  z-index: 1;
}

.mainroom .stream {
  border-radius: 0;
  position: relative;
  gap: 0;
  width: 100%;
  height: calc(100% - 80px);
  border: none;
  bottom: 0;
  overflow-y: auto;
  background-color: inherit;
  padding: 16px;
}

.mainroom .stream .liveVdoWrap {
  width: 100%;
  height: 100%;
  display: flex;
  flex-wrap: wrap;
  align-content: center;
  justify-content: center;
  align-items: center;
}

.mainroom .stream .liveVdoWrap div {
  width: auto;
  height: inherit;
}

@media (max-width: 991px) {
  .mainroom .stream .liveVdoWrap {
    width: auto;
    height: auto;
  }
}

.mainroom .box {
  position: relative;
  width: 100%;
  height: 100%;
  border: 0;
  display: flex;
  flex: 1 1 auto;
  padding: 0;
  margin: 0;
  min-width: 180px;
  min-height: 180px;
  justify-content: center;
}

.mainroom .box p {
  z-index: 1;
  position: absolute;
  /* background: #222; */
  padding: 0px 10px;
  border-radius: 15px;
  font-size: 1em;
  bottom: 0px;
  margin: 0px;
}

.mainroom .box button {
  z-index: 1;
  position: absolute;
  background: #3c4044;
  padding: 0;
  border-radius: 50%;
  bottom: 0px;
  margin: 0px;
  color: #ffffff;
  right: 0;
  height: 40px;
  width: 40px;
}

.mainroom .box span {
  z-index: 1;
  position: absolute;
  background: #34732b;
  padding: 0;
  border-radius: 50%;
  font-size: 300%;
  color: rgb(255, 255, 255);
  top: calc(50% - 50px);
  left: calc(50% - 50px);
  margin: 0;
  width: 100px;
  height: 100px;
  text-align: center;
  vertical-align: middle;
  line-height: 100px;
}

.mainroom .video {
  width: 100%;
  height: 100%;
  min-width: 180px;
  min-height: 180px;
  background-color: inherit;
  aspect-ratio: 3 / 2;
  transform: scaleX(-1);
  /* border: 1px solid #000; */
}

.mainroom .controls {
  display: flex;
  width: 100%;
  align-items: center;
  padding: 20px 0;
  height: 80px;
  margin-top: 0;
  background-color: inherit;
  color: white;
  border-radius: 0;
  gap: 10px;
  flex-wrap: wrap;
  justify-content: center;
}

.mainroom .controls button,
.mainroom .controls label {
  min-width: 45px;
  min-height: 45px;
  border: 0;
  background: #3c4043;
  font-weight: bold;
  color: white;
}

.mainroom .controls .audio-disable,
.mainroom .controls .videoicon-disable {
  background: #dc3545;
  color: white;
}

.mainroom .controls .stop-streaming,
.mainroom .controls .record-enable {
  color: white;
  background: #dc3545;
}

.mainroom .controls .chat-enable {
  color: #1976d2;
}

.mainroom .controls .loading {
  color: #d2c919;
}

.mainroom .controls .record-disable:hover,
.mainroom .controls .goLive-disable:hover {
  color: white;
  background: #1976d2;
}

@media (max-width: 768px) {
  .mainroom .rightBox {
    min-width: 240px;
  }
}

@media (max-width: 575px) {
  .mainroom .stream {
    height: calc(100% - 160px);
  }

  .mainroom .controls {
    height: 160px;
    display: flex;
    align-content: center;
    justify-content: center;
    flex-wrap: wrap;
  }

  .mainroom .rightBox {
    width: 80%;
    display: block;
    position: absolute;
    height: calc(100% - 160px);
  }
}

/* livesessionroom */

.livesessionroom {
  display: flex;
  background: #000;
  position: relative;
  border-radius: 0;
  border: none;
  width: 100%;
  height: 100%;
  margin: 0;
  padding: 0;
}

.livesessionroom .room__streamSpace {
  position: relative;
  width: 100%;
  height: calc(100vh - 220px);
  border: none;
  top: inherit;
  left: inherit;
  border-radius: 0;
  min-height: 360px;
}

.livesessionroom .rightBox {
  position: relative;
  width: 30%;
  height: calc(100vh - 220px);
  border: none;
  top: inherit;
  left: inherit;
  border-radius: 0;
  min-width: 240px;
  min-height: 360px;
}

.livesessionroom .stream {
  align-items: center;
  background-color: #000;
  border-radius: 0;
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  height: 100%;
  justify-content: center;
  overflow: hidden;
  border: none;
}

.livesessionroom .video {
  height: 50%;
  width: calc(50% - 10px);
  flex: 1 1 auto;
  display: flex;
  border: 0;
  padding: 0;
  margin: 0;
}

@media (max-width: 991px) {
  .livesessionroom {
    flex-direction: column;
  }

  .livesessionroom .room__streamSpace {
    width: 100%;
    height: calc(100vh - 40vh);
    min-height: 360px;
  }

  .livesessionroom .rightBox {
    width: 100%;
    height: calc(100vh - 40vh);
    min-height: 240px;
  }
}

.mainroom .hide {
  opacity: 0;
  display: none;
  width: 0;
  height: 0;
  position: absolute;
  top: 0;
}

/* livesessionroom */

.txtBx p {
  max-height: 80px;
  overflow: hidden;
}

.loading {
  margin: 50px auto;
  text-align: center;
}

@media (min-width: 991px) and (max-width: 2000px) {
  .footerLogo {
    max-width: 58%;
  }
}

/*Video*/
.mainroom {
  width: 94vw !important;
  height: 85vh !important;
}

.right-join-img {
  background-color: #202123;
}

.right-join-img {
  height: 85vh !important;
  right: 0px;
  top: inherit;
  background-color: #202123;
  bottom: 0;
  width: 6vw;
}

.top-join-img {
  height: 15vh;
  background: #202124;
}

/* dontdo anything */

.right-join-img {
  height: 83vh;
}

.col-1 .right-join-img {
  z-index: 1;
}

.dbateSldr p {
  height: 70px;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
}`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT,UAAU;EACV,sBAAsB;AACxB;;AAEA;EACE,SAAS;EACT;;cAEY;EACZ,mCAAmC;EACnC,kCAAkC;EAClC,0CAA0C;AAC5C;;AAEA;EACE;aACW;AACb;;AAEA;EACE,WAAW;EACX,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,mBAAmB;EACnB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,cAAc;EACd,iBAAiB;AACnB;;AAEA,cAAc;AACd;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,gBAAgB;EAChB,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,4CAA4C;EAC5C,cAAc;AAChB;;AAEA;;;EAGE,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,oCAAoC;EACpC,eAAe;AACjB;;AAEA;;EAEE,wBAAwB;AAC1B;;AAEA;;EAEE,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;;AAEA,uBAAuB;AACvB;EACE,yBAAyB;EACzB,mBAAmB;EACnB,UAAU;EACV,uBAAuB;EACvB,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;EAChB,aAAa;EACb,iBAAiB;EACjB,2BAA2B;EAC3B,mBAAmB;EACnB,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;AACV;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,mBAAmB;EACnB,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,gBAAgB;EAChB,qBAAqB;EACrB,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA,aAAa;AACb;EACE,aAAa;EACb,WAAW;EACX,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,kCAAkC;AACpC;;AAEA,0BAA0B;AAC1B;EACE,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,yBAAyB;AAC3B;;AAEA;EACE,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,WAAW;EACX,2BAA2B;EAC3B,uBAAuB;AACzB;;AAEA,YAAY;AACZ;EACE,uBAAkB;EAAlB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA,SAAS;AACT;EACE,aAAa;EACb,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;;;;;;;;;;GAUG;;AAEH,WAAW;AACX;EACE,6BAA6B;EAC7B,yBAAyB;EACzB,mBAAmB;EACnB,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,2BAA2B;EAC3B,yBAAyB;EACzB,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,WAAW;EACX,QAAQ;EACR,OAAO;EACP,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,gBAAgB;EAChB,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,MAAM;EACN,WAAW;EACX,yBAAyB;EACzB,YAAY;EACZ,SAAS;EACT,gBAAgB;EAChB,yBAAyB;EACzB,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,eAAe;EACf,qBAAqB;EACrB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE;IACE,WAAW;IACX,YAAY;EACd;AACF;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,SAAS;EACT,aAAa;EACb,cAAc;EACd,UAAU;EACV,SAAS;EACT,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;EACE,UAAU;EACV,kBAAkB;EAClB,sBAAsB;EACtB,iBAAiB;EACjB,mBAAmB;EACnB,cAAc;EACd,WAAW;EACX,WAAW;AACb;;AAEA;EACE,UAAU;EACV,kBAAkB;EAClB,mBAAmB;EACnB,UAAU;EACV,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,cAAc;EACd,QAAQ;EACR,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,UAAU;EACV,kBAAkB;EAClB,mBAAmB;EACnB,UAAU;EACV,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,qBAAqB;EACrB,sBAAsB;EACtB,SAAS;EACT,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;EACzB,mBAAmB;EACnB,qBAAqB;EACrB,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,WAAW;EACX,mBAAmB;EACnB,eAAe;EACf,YAAY;EACZ,aAAa;EACb,yBAAyB;EACzB,YAAY;EACZ,gBAAgB;EAChB,SAAS;EACT,eAAe;EACf,uBAAuB;AACzB;;AAEA;;EAEE,eAAe;EACf,gBAAgB;EAChB,SAAS;EACT,mBAAmB;EACnB,iBAAiB;EACjB,YAAY;AACd;;AAEA;;EAEE,mBAAmB;EACnB,YAAY;AACd;;AAEA;;EAEE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;;EAEE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,aAAa;IACb,aAAa;IACb,qBAAqB;IACrB,uBAAuB;IACvB,eAAe;EACjB;;EAEA;IACE,UAAU;IACV,cAAc;IACd,kBAAkB;IAClB,0BAA0B;EAC5B;AACF;;AAEA,oBAAoB;;AAEpB;EACE,aAAa;EACb,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,2BAA2B;EAC3B,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,2BAA2B;EAC3B,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;EACtB,gBAAgB;EAChB,aAAa;EACb,eAAe;EACf,SAAS;EACT,YAAY;EACZ,uBAAuB;EACvB,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,uBAAuB;EACvB,cAAc;EACd,aAAa;EACb,SAAS;EACT,UAAU;EACV,SAAS;AACX;;AAEA;EACE;IACE,sBAAsB;EACxB;;EAEA;IACE,WAAW;IACX,0BAA0B;IAC1B,iBAAiB;EACnB;;EAEA;IACE,WAAW;IACX,0BAA0B;IAC1B,iBAAiB;EACnB;AACF;;AAEA;EACE,UAAU;EACV,aAAa;EACb,QAAQ;EACR,SAAS;EACT,kBAAkB;EAClB,MAAM;AACR;;AAEA,oBAAoB;;AAEpB;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE;IACE,cAAc;EAChB;AACF;;AAEA,QAAQ;AACR;EACE,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,uBAAuB;EACvB,UAAU;EACV,YAAY;EACZ,yBAAyB;EACzB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,oBAAoB;;AAEpB;EACE,YAAY;AACd;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;AAC9B","sourcesContent":["* {\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n}\n\nbody {\n  margin: 0;\n  font-family: -apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Roboto\", \"Oxygen\",\n    \"Ubuntu\", \"Cantarell\", \"Fira Sans\", \"Droid Sans\", \"Helvetica Neue\",\n    sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  /* background-color: hsl(228, 25%, 88%); */\n}\n\ncode {\n  font-family: source-code-pro, Menlo, Monaco, Consolas, \"Courier New\",\n    monospace;\n}\n\n.wrapper {\n  width: 95vw;\n  margin: 0 auto;\n  display: block;\n}\n\n.wrapper {\n  width: 95%;\n  /* height: 100vh; */\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  margin: 0 auto;\n  max-width: 1200px;\n}\n\n/* Join Room */\n.join {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  max-width: 400px;\n  gap: 10px;\n  padding: 40px 20px;\n  border-radius: 10px;\n  box-shadow: 0 2px 8px 2px rgb(164, 165, 168);\n  margin: 0 auto;\n}\n\n.join input,\nselect,\nbutton {\n  height: 45px;\n  border: none;\n  outline: none;\n  color: rgb(59, 60, 62);\n  border-radius: 4px;\n  border: 1px solid rgb(182, 184, 190);\n  font-size: 16px;\n}\n\n.join input::placeholder,\nselect::placeholder {\n  color: hsl(223, 3%, 56%);\n}\n\n.join input,\nselect {\n  padding: 0 10px;\n}\n\n.join button:hover {\n  background-color: inherit;\n}\n\n.join button:active {\n  background-color: rgb(201, 205, 220);\n}\n\n/* ChatNdParticipants */\n.rightBox {\n  border: 1px #c2c2c2 solid;\n  border-radius: 10px;\n  width: 30%;\n  background-color: white;\n  min-width: 250px;\n  padding: 20px 15px;\n  height: 100%;\n}\n\n.rightBox__optionView {\n  height: calc(100% - 45px);\n}\n\n.rightBox__head {\n  width: 100%;\n  text-align: left;\n  height: auto;\n  min-height: 45px;\n  display: flex;\n  flex-wrap: nowrap;\n  justify-content: flex-start;\n  flex-direction: row;\n  align-items: center;\n  vertical-align: middle;\n  position: relative;\n}\n\n.rightBox__head .selected {\n  color: black;\n}\n\n.rightBox__head span {\n  font-weight: bold;\n  color: #a6a8ab;\n  cursor: pointer;\n}\n\n.rightBox__head span:nth-child(1) {\n  margin-right: 10px;\n}\n\n.rightBox__head button {\n  position: absolute;\n  right: 0;\n}\n\n.rightBox__chats {\n  height: calc(100% - 40px);\n  overflow: scroll;\n  padding: 10px 0;\n  scrollbar-width: none;\n}\n\n.rightBox__chats::-webkit-scrollbar {\n  display: none;\n}\n\n.rightBox__optionView form input {\n  border: none;\n  width: 100%;\n  height: 40px;\n  background-color: hsl(228, 25%, 88%);\n  border-radius: 10px;\n  padding: 0 10px;\n  box-sizing: border-box;\n}\n\n.rightBox__optionView form input:focus {\n  outline: none;\n}\n\n.rightBox__participants {\n  padding: 10px 0;\n  height: 100%;\n  overflow: scroll;\n  scrollbar-width: none;\n  /* Firefox */\n}\n\n.rightBox__participants::-webkit-scrollbar {\n  display: none;\n}\n\n.rightBox__participant {\n  text-align: left;\n  text-align: left;\n  background-color: #e9ebef;\n  padding: 10px;\n  border-radius: 10px;\n  margin-bottom: 10px;\n}\n\n.rightBox__participant p {\n  font-size: 14px;\n}\n\n/* Controls */\n.controls {\n  display: flex;\n  width: 100%;\n  align-items: center;\n  justify-content: center;\n  padding: 20px 0;\n  height: 80px;\n  margin-top: 10px;\n  background-color: white;\n  border-radius: 10px;\n  gap: 10px;\n}\n\n.controls .MuiButton-root .MuiSvgIcon-root {\n  margin-right: 5px;\n}\n\n.controls .MuiButton-root img {\n  height: 20px;\n  width: 20px;\n  margin-left: 5px;\n}\n\n.controls .MuiButton-root {\n  text-transform: unset;\n  padding: 10px;\n  border-radius: 10px;\n}\n\n.controls .leave {\n  background-color: rgb(241, 110, 110);\n}\n\n.controls .leave:hover {\n  background-color: rgb(242, 87, 87);\n}\n\n/* HlsView and VideoTile */\nvideo {\n  width: 100%;\n  height: 100%;\n  /* object-fit: cover; */\n  /* border-radius: 10px; */\n}\n\n.video {\n  width: calc(50% - 10px);\n  height: unset;\n}\n\n.video-theater {\n  width: 100%;\n  height: calc(100vh - 180px);\n  background-color: black;\n}\n\n/* Message */\n.message {\n  width: fit-content;\n  text-align: left;\n  max-width: 90%;\n}\n\n.message span {\n  font-size: 12px;\n  color: rgb(191, 196, 199);\n  display: block;\n}\n\n.message p {\n  background-color: hsl(228, 10%, 90%);\n  padding: 5px 10px;\n  border-radius: 10px;\n  font-size: 14px;\n  overflow: hidden;\n  margin-bottom: 5px;\n}\n\n.myMessage {\n  margin-left: auto;\n  text-align: right;\n}\n\n.myMessage p {\n  background-color: #1d84ea;\n  color: white;\n}\n\n/* Room */\n.room {\n  display: flex;\n  width: 95vw;\n  height: 72vh;\n  border: 1px white solid;\n  gap: 10px;\n}\n\n.room__streamSpace {\n  width: 100%;\n  height: 100%;\n  border: 1px #c2c2c2 solid;\n  border-radius: 10px;\n}\n\n/* .liveStream {\n  border-radius: 10px;\n  border: 1px black solid;\n  height: calc(100% - 90px);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 10px;\n  flex-wrap: wrap;\n  overflow: hidden;\n} */\n\n/* Stream */\n.stream {\n  /* border: 1px black solid; */\n  background-color: #202124;\n  border-radius: 10px;\n  height: calc(100% - 90px);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  /* gap: 10px; */\n  flex-wrap: wrap;\n  overflow: hidden;\n}\n\n.mainroom {\n  display: flex;\n  justify-content: flex-start;\n  background-color: #202124;\n  position: fixed;\n  border-radius: 0;\n  border: none;\n  width: 100vw;\n  height: 100vh;\n  z-index: 99;\n  gap: 0px;\n  left: 0;\n  bottom: 0;\n}\n\n.mainroom .room__streamSpace {\n  position: relative;\n  width: 100%;\n  height: 100%;\n  border: none;\n  top: inherit;\n  left: inherit;\n  border-radius: 0;\n}\n\n.mainroom .rightBox {\n  position: relative;\n  width: 50%;\n  height: 100%;\n  border: none;\n  top: inherit;\n  left: inherit;\n  border-radius: 0;\n  min-width: 300px;\n  z-index: 1;\n}\n\n.mainroom .stream {\n  border-radius: 0;\n  position: relative;\n  gap: 0;\n  width: 100%;\n  height: calc(100% - 80px);\n  border: none;\n  bottom: 0;\n  overflow-y: auto;\n  background-color: inherit;\n  padding: 16px;\n}\n\n.mainroom .stream .liveVdoWrap {\n  width: 100%;\n  height: 100%;\n  display: flex;\n  flex-wrap: wrap;\n  align-content: center;\n  justify-content: center;\n  align-items: center;\n}\n\n.mainroom .stream .liveVdoWrap div {\n  width: auto;\n  height: inherit;\n}\n\n@media (max-width: 991px) {\n  .mainroom .stream .liveVdoWrap {\n    width: auto;\n    height: auto;\n  }\n}\n\n.mainroom .box {\n  position: relative;\n  width: 100%;\n  height: 100%;\n  border: 0;\n  display: flex;\n  flex: 1 1 auto;\n  padding: 0;\n  margin: 0;\n  min-width: 180px;\n  min-height: 180px;\n  justify-content: center;\n}\n\n.mainroom .box p {\n  z-index: 1;\n  position: absolute;\n  /* background: #222; */\n  padding: 0px 10px;\n  border-radius: 15px;\n  font-size: 1em;\n  bottom: 0px;\n  margin: 0px;\n}\n\n.mainroom .box button {\n  z-index: 1;\n  position: absolute;\n  background: #3c4044;\n  padding: 0;\n  border-radius: 50%;\n  bottom: 0px;\n  margin: 0px;\n  color: #ffffff;\n  right: 0;\n  height: 40px;\n  width: 40px;\n}\n\n.mainroom .box span {\n  z-index: 1;\n  position: absolute;\n  background: #34732b;\n  padding: 0;\n  border-radius: 50%;\n  font-size: 300%;\n  color: rgb(255, 255, 255);\n  top: calc(50% - 50px);\n  left: calc(50% - 50px);\n  margin: 0;\n  width: 100px;\n  height: 100px;\n  text-align: center;\n  vertical-align: middle;\n  line-height: 100px;\n}\n\n.mainroom .video {\n  width: 100%;\n  height: 100%;\n  min-width: 180px;\n  min-height: 180px;\n  background-color: inherit;\n  aspect-ratio: 3 / 2;\n  transform: scaleX(-1);\n  /* border: 1px solid #000; */\n}\n\n.mainroom .controls {\n  display: flex;\n  width: 100%;\n  align-items: center;\n  padding: 20px 0;\n  height: 80px;\n  margin-top: 0;\n  background-color: inherit;\n  color: white;\n  border-radius: 0;\n  gap: 10px;\n  flex-wrap: wrap;\n  justify-content: center;\n}\n\n.mainroom .controls button,\n.mainroom .controls label {\n  min-width: 45px;\n  min-height: 45px;\n  border: 0;\n  background: #3c4043;\n  font-weight: bold;\n  color: white;\n}\n\n.mainroom .controls .audio-disable,\n.mainroom .controls .videoicon-disable {\n  background: #dc3545;\n  color: white;\n}\n\n.mainroom .controls .stop-streaming,\n.mainroom .controls .record-enable {\n  color: white;\n  background: #dc3545;\n}\n\n.mainroom .controls .chat-enable {\n  color: #1976d2;\n}\n\n.mainroom .controls .loading {\n  color: #d2c919;\n}\n\n.mainroom .controls .record-disable:hover,\n.mainroom .controls .goLive-disable:hover {\n  color: white;\n  background: #1976d2;\n}\n\n@media (max-width: 768px) {\n  .mainroom .rightBox {\n    min-width: 240px;\n  }\n}\n\n@media (max-width: 575px) {\n  .mainroom .stream {\n    height: calc(100% - 160px);\n  }\n\n  .mainroom .controls {\n    height: 160px;\n    display: flex;\n    align-content: center;\n    justify-content: center;\n    flex-wrap: wrap;\n  }\n\n  .mainroom .rightBox {\n    width: 80%;\n    display: block;\n    position: absolute;\n    height: calc(100% - 160px);\n  }\n}\n\n/* livesessionroom */\n\n.livesessionroom {\n  display: flex;\n  background: #000;\n  position: relative;\n  border-radius: 0;\n  border: none;\n  width: 100%;\n  height: 100%;\n  margin: 0;\n  padding: 0;\n}\n\n.livesessionroom .room__streamSpace {\n  position: relative;\n  width: 100%;\n  height: calc(100vh - 220px);\n  border: none;\n  top: inherit;\n  left: inherit;\n  border-radius: 0;\n  min-height: 360px;\n}\n\n.livesessionroom .rightBox {\n  position: relative;\n  width: 30%;\n  height: calc(100vh - 220px);\n  border: none;\n  top: inherit;\n  left: inherit;\n  border-radius: 0;\n  min-width: 240px;\n  min-height: 360px;\n}\n\n.livesessionroom .stream {\n  align-items: center;\n  background-color: #000;\n  border-radius: 0;\n  display: flex;\n  flex-wrap: wrap;\n  gap: 10px;\n  height: 100%;\n  justify-content: center;\n  overflow: hidden;\n  border: none;\n}\n\n.livesessionroom .video {\n  height: 50%;\n  width: calc(50% - 10px);\n  flex: 1 1 auto;\n  display: flex;\n  border: 0;\n  padding: 0;\n  margin: 0;\n}\n\n@media (max-width: 991px) {\n  .livesessionroom {\n    flex-direction: column;\n  }\n\n  .livesessionroom .room__streamSpace {\n    width: 100%;\n    height: calc(100vh - 40vh);\n    min-height: 360px;\n  }\n\n  .livesessionroom .rightBox {\n    width: 100%;\n    height: calc(100vh - 40vh);\n    min-height: 240px;\n  }\n}\n\n.mainroom .hide {\n  opacity: 0;\n  display: none;\n  width: 0;\n  height: 0;\n  position: absolute;\n  top: 0;\n}\n\n/* livesessionroom */\n\n.txtBx p {\n  max-height: 80px;\n  overflow: hidden;\n}\n\n.loading {\n  margin: 50px auto;\n  text-align: center;\n}\n\n@media (min-width: 991px) and (max-width: 2000px) {\n  .footerLogo {\n    max-width: 58%;\n  }\n}\n\n/*Video*/\n.mainroom {\n  width: 94vw !important;\n  height: 85vh !important;\n}\n\n.right-join-img {\n  background-color: #202123;\n}\n\n.right-join-img {\n  height: 85vh !important;\n  right: 0px;\n  top: inherit;\n  background-color: #202123;\n  bottom: 0;\n  width: 6vw;\n}\n\n.top-join-img {\n  height: 15vh;\n  background: #202124;\n}\n\n/* dontdo anything */\n\n.right-join-img {\n  height: 83vh;\n}\n\n.col-1 .right-join-img {\n  z-index: 1;\n}\n\n.dbateSldr p {\n  height: 70px;\n  overflow: hidden;\n  display: -webkit-box;\n  -webkit-line-clamp: 3;\n  -webkit-box-orient: vertical;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
